<section>
    <div class="container my-4">
        <div class="my-2">
            <h2>{{ model_data.name }}</h2>
<p><b>Code Name:</b> {{ model_data.codeName }}</p>
<p><b>Currency:</b> {{ model_data.currency }}</p>
<p><b>Description:</b> <span [innerHTML]="model_data.description"></span></p>
<p><b>Notes:</b> <span [innerHTML]="model_data.notes"></span></p>
<p><b>Admin Notes:</b> <span [innerHTML]="model_data.admin_notes"></span></p>
<p><b>Alert Notes:</b> <span [innerHTML]="model_data.alert_notes"></span></p>
<p><b>Feature:</b> <span [innerHTML]="model_data.feature"></span></p>
<p><b>Domain:</b> <span [innerHTML]="model_data.domain"></span></p>
<p><b>Config Notes:</b> <span [innerHTML]="model_data.config_notes"></span></p>
<p><b>Demo Notes:</b> <span [innerHTML]="model_data.demo_notes"></span></p>
<p><b>Status:</b> {{ model_data.status[0]?.displayname }}</p>
<p><b>Priority:</b> {{ model_data.priority[0]?.displayname }}</p>
<p><b>Owner:</b> {{ model_data.owner?.name }}</p>
<p><b>Auditor:</b> {{ model_data.auditor?.name }}</p>
<p><b>Marketer:</b> {{ model_data.marketer?.name }}</p>
<p><b>Publisher:</b> {{ model_data.publisher?.name }}</p>
<p><b>Work On:</b>
    <span *ngFor="let w of model_data.workon; let last = last">
      {{ w.displayname }}<span *ngIf="!last">, </span>
    </span>
  </p>
  <p><b>Source:</b>
    <span *ngFor="let s of model_data.source; let last = last">
      {{ s.displayname }}<span *ngIf="!last">, </span>
    </span>
  </p>
  <p><b>Technology:</b>
    <span *ngFor="let t of model_data.technology; let last = last">
      {{ t.displayname }}<span *ngIf="!last">, </span>
    </span>
  </p>
  <p><b>Skills:</b>
    <span *ngFor="let s of model_data.skills; let last = last">
      {{ s.displayname }}<span *ngIf="!last">, </span>
    </span>
  </p>
  <p><b>References:</b>
    <span *ngFor="let ref of model_data.references">
      <a [href]="ref.links" target="_blank">{{ ref.name }}</a>
    </span>
  </p>
    <p><b>Project Tag:</b> {{ model_data.project_tag?.displayname }}</p>
<p><b>Development Stage:</b> {{ model_data.developmentStage?.displayname }}</p>
<p><b>Market Stage:</b> {{ model_data.marketStage?.displayname }}</p>
<p><b>Config State:</b> {{ model_data.configState?.displayname }}</p>
<p><b>Model Category:</b> {{ model_data.modelCategory?.displayname }}</p>
<p><b>Model Variant:</b> {{ model_data.modelVariant?.displayname }}</p>
<p><b>Model Source:</b> {{ model_data.modelSource?.displayname }}</p>
        </div>
        
    </div>
  
</section>